import { format, parseISO, isValid } from 'date-fns';

/**
 * Formats a date string to DD/MM/YYYY format.
 * @param dateString The date string to format (preferably in ISO 8601 format).
 * @returns The formatted date string or an empty string if the input is invalid.
 */
export const formatDateToDDMMYYYY = (dateString: string | undefined): string => {
  if (!dateString) {
    return '';
  }
  const date = parseISO(dateString);
  return isValid(date) ? format(date, 'dd/MM/yyyy') : dateString;
};



export const getColor = (status: string) => {

  if(status==='PENDING APPROVAL'){
    return('var(--status-pending-approval)')
  }else if(status==='PENDING DELIVERY')
    {
    return('var(--status-pending-delivery)')
  }
  else if(status==='CERTIFICATE ISSUANCE'){
    return('var(--status-certificate-issuance)')
  }
  else if(status==='ACTIVE'){
    return('var(--status-active)')
  
  }else if(status==='REJECTED'){
    return('var(--status-rejected)')
  }
}